import { OnboardingTask } from '@tiendanube/common';
import OnboardingPromoteTasksSkeleton from './OnboardingPromoteTasksSkeleton';
import GenericTaskList, { GenericTaskItem } from '../GenericTaskList';

interface OnboardingPromoteTasksProps {
  tasks: OnboardingTask[];
  onAction: (task: OnboardingTask) => void;
  onSkip?: (task: OnboardingTask) => void;
  type: 'recommendation' | 'promote';
}

const onboardingTaskDigest = (
  task: OnboardingTask,
  type: 'recommendation' | 'promote',
): GenericTaskItem => ({
  id: task.name,
  title: task.title,
  description: task.description,
  iconType: task.name,
  ctaText: task.ctaText,
  ctaLink: task.ctaLink,
  videoId: task?.videoId,
  contentType: type,
  actionType: type,
});

function OnboardingPromoteTasks({
  tasks,
  onAction,
  onSkip,
  type,
}: OnboardingPromoteTasksProps) {
  const paddingVertical = type === 'recommendation' ? '2' : '4';

  const adaptedItems = tasks.map((task) => onboardingTaskDigest(task, type));

  const handleAction = (item: any) => {
    const originalTask = tasks.find((task) => task.name === item.id);
    if (originalTask) {
      onAction(originalTask);
    }
  };

  const handleSkip = onSkip
    ? (item: any) => {
        const originalTask = tasks.find((task) => task.name === item.id);
        if (originalTask && onSkip) {
          onSkip(originalTask);
        }
      }
    : undefined;

  return (
    <GenericTaskList
      items={adaptedItems}
      onAction={handleAction}
      onSkip={handleSkip}
      className="stratus--onboarding-promote-tasks"
      paddingVertical={paddingVertical}
      variant={type === 'recommendation' ? 'recommendations' : 'default'}
    />
  );
}

OnboardingPromoteTasks.Skeleton = OnboardingPromoteTasksSkeleton;

export default OnboardingPromoteTasks;
